<template>
  <div id="adminassessmenttemplates">
    <div class="pa-2">
      <v-row justify="space-between">
        <v-col cols="12">
          <AssessmentTemplates />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script lang="ts">
import AssessmentTemplates from "@/components/admin-components/global/AssessmentTemplates.vue";
export default {
  name: "AdminAssessmentTemplates",
  components: { AssessmentTemplates },
  data: () => ({}),
};
</script>